import {match} from 'ts-pattern';

import {VisibleColumnsBody} from '@dms/api/core';

import {KANBAN_COLUMNS, KANBAN_COLUMN_KEYS} from './kanbanColumns';
import {KANBAN_SEGMENTS} from './kanbanSegments';

export const KANBAN_DEFAULT_VISIBLE_COLUMNS: VisibleColumnsBody[] = [
  KANBAN_SEGMENTS.reduce(
    (visibleColumns, segment) => {
      visibleColumns[segment.value] = KANBAN_COLUMNS.reduce((columns, column) => {
        const value = match([segment.value, column.key])
          .with(['BUYING', KANBAN_COLUMN_KEYS.PAYMENT_REQUEST], () => false)
          .with(['BUYING', KANBAN_COLUMN_KEYS.PAYMENT_RECEIVED], () => false)
          .with(['BUYING', KANBAN_COLUMN_KEYS.INVOICE], () => false)
          .otherwise(() => true);
        return {...columns, [column.key]: value};
      }, {});
      return visibleColumns;
    },
    {} as {[segment: string]: {[columnKey: string]: boolean}}
  ),
];
